<template>
    <mdb-container fluid>    
        <mdb-row class="justify-content-md-center">
           <mdb-col lg="10" sm="10" :class=" 'content-top-btm-space' + textAlignCsAr "> 
               <mdb-row>
                   <page-tools v-if="( copyright_type=='' || copyright_type == 'Public' || copyright_type == 'public' || copyright_type == 'WPO' || copyright_type == 'wpo')"/>
               </mdb-row>
                <mdb-row class="content-top-btm-space">
                    <div class="desc main-cont">            
                        <h1 id="top" v-html="main_content['title']" ></h1>
                        <p v-if="returnmsg==''" v-html="main_content['body_combine']" @click.capture="handleClick"></p>
                        <p v-else v-html="returnmsg"></p>
                        <hr/>
                        <p v-if="returnmsg==''" v-html="main_content['source']"></p>
                    </div>
                </mdb-row>               
           </mdb-col>      
        </mdb-row>
        <link v-if="RTL_LANG.includes(lang_id)" rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazineClassic/css/arabic-support.css'">
    </mdb-container>
</template>
<script>
import axios from 'axios';
import { mdbRow, mdbContainer, mdbCol } from 'mdbvue';
import PageTools from '@/components/ThemeMDB/pages/contentPage/partials/PageTools';
export default {
    name: 'Body',
    data(){
        return{
            main_content:[],
            copyright_type:'',           
            content_id :'', 
            someValue:'',
            returnmsg:'',
            lang_id:localStorage.id_language,
            RTL_LANG:this.$store.state.RTL_LANG
        }        
    },
    components:{        
        mdbContainer,
        mdbRow,
        mdbCol,
        PageTools
    },
    computed:{
        textAlignCsAr(){ if(this.RTL_LANG.includes(this.lang_id)) {return ' text-align-cs-ar'}else{return '';}}
    },
    mounted: function(){
        //this.showContent(this.$route.params.id)
    },
    created:function(){
      
       this.showContent(this.$route.params.id)
    },
    methods:{
        showContent(cr_id){           
            this.content_id=cr_id;
             axios.get(this.$store.state.apiUrl+'/content_detail_direct',{
                params:{
                    id_cr:cr_id
                    //id_company:'nosession',
                    //id_language:''
                    //privatekey:api_private_key                  
                }
            })
            .then(response => {              
                    response = response.data
                    this.main_content = response[0],
                    this.copyright_type=this.main_content['copyright_type'];
                    this.someValue= this.main_content['title'];
                    this.lang_id=this.main_content['id_language'];
                    var test = document.title;
                    //document.title = this.decodeHtmlLang(test)+' | '+this.decodeHtmlLang(this.someValue);
                    
            })
            .catch((error) => {
                    this.main_content = [];
                    //this.customErrorHandler(error.response.status);
            });
        }
        
    } 
};

</script>
<style scoped>
.content-top-btm-space{
    padding: 55px 0;
}
h2{color: #276d96c7;}
.text-align-cs-ar{
    text-align: right !important;
    direction: rtl !important;
}
</style>
